import React, { useEffect, useState } from 'react'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import asideModalStore from 'Stores/asideModalStore'
import InputFlagPhone from 'components/ContentBox/Global/InputPhone/InputFlagPhone/InputFlagPhone'
import SmartFilter from 'components/ContentBox/Global/Filter/SmartFilter'
import SelectCustom from 'components/ContentBox/Global/Select/SelectCustom'
import st from './AddNewUser.module.scss'
import { observer } from 'mobx-react'
import useLocalization from 'hooks/useLocalization'

const AddNewUser = ({ userData, addNewUser }) => {
  const {
    changeValues: changeValuesArray,
    modalValues: modalValue,
    modalSettings: ms,
    check,
    changeValue,
  } = asideModalStore

  const { translate } = useLocalization({
    section: 'ebooks',
    subsection: 'ebooks_books',
    dict: {
      name: 'Name',
      edit_employee: 'Edit Employee',
      first_name: 'First Name',
      last_name: 'Last Name',
      contacts: 'Contacts',
      short_number: 'Short number',
      update: 'Update',
      branch: 'Branch',
      role: 'Role',
    },
  })

  const [udIfFind, setudIfFind] = useState(false)

  const getStudentList = (value) => {
    const profile = value[0]?.profile

    setudIfFind(true)
    changeValuesArray({
      first_name: profile?.first_name,
      last_name: profile?.last_name,
      mobile_phone: profile?.mobile_phone || profile?.phone,
      email: value[0]?.email,
      // branch: value[0].id,
      role_id: profile.crm_role?.id,
      phoenix_id: value[0]?.id,
    })

    ms.link = 'integration/employees'
    ms.crm = true
  }

  useEffect(() => {
    if (userData?.sipuni_short_number) {
      changeValue(userData?.sipuni_short_number, 'sipuni_short_number')
    }
  }, [userData])

  return (
    <div>
      {addNewUser && (
        <div className={st.smartFilter}>
          <FormField>
            <SmartFilter
              link='accounts/employers_list'
              placeholder={translate.name}
              new_key='full_name'
              sub_key='profile'
              backFunction={getStudentList}
              emptyValue={true}
            />
          </FormField>
        </div>
      )}

      {modalValue.phoenix_id && (
        <div className={st.field}>
          <FormField>
            <FormLabel isRequired>{translate.first_name}:</FormLabel>
            <FormInput isError={check('first_name')}>
              <input
                placeholder={translate.first_name}
                type='text'
                disabled={udIfFind}
                value={modalValue.first_name || ''}
                onChange={(e) => changeValue(e.target.value, 'first_name')}
              />
            </FormInput>
          </FormField>
          <FormField>
            <FormLabel isRequired>{translate.last_name}:</FormLabel>
            <FormInput isError={check('last_name')}>
              <input
                placeholder={translate.last_name}
                type='text'
                disabled={udIfFind}
                value={modalValue.last_name || ''}
                onChange={(e) => changeValue(e.target.value, 'last_name')}
              />
            </FormInput>
          </FormField>

          <FormField>
            <FormLabel isRequired>{translate.contacts}:</FormLabel>
            <InputFlagPhone
              error={check('mobile_phone')}
              value={modalValue.mobile_phone || ''}
              disabled={udIfFind}
              onChange={(val) => changeValue(val, 'mobile_phone')}
            />
          </FormField>

          <FormField>
            <FormLabel>Выбрать канал:</FormLabel>
            <SelectCustom
              placeholder={'Выбрать канал'}
              valueID={modalValue?.wazzup_channel || [] || null}
              onChange={(temp) =>
                changeValue(temp.channel_id, 'wazzup_channel')
              }
              apiLinkCRM={'integration/channels'}
              error={check('wazzup_channel')}
              optionValueKey='channel_id'
              getOptionValue={(option) => option.channel_id}
            />
          </FormField>

          <FormField>
            <FormLabel isRequired>E-mail</FormLabel>
            <FormInput isError={check('email')}>
              <input
                placeholder='Email'
                type='email'
                disabled={udIfFind}
                value={modalValue.email || ''}
                onChange={(e) => changeValue(e.target.value, 'email')}
              />
            </FormInput>
          </FormField>

          <FormField>
            <FormLabel isRequired>{translate.branch}:</FormLabel>
            <FormInput isError={check('branch')}>
              <SelectCustom
                placeholder={translate.branch}
                apiLinkCRM={'integration/branches'}
                sortKey='name'
                valueID={modalValue.branch}
                onChange={(o) => changeValue(o.id, 'branch')}
                error={check('branch')}
              />
            </FormInput>
          </FormField>

          <FormField>
            <FormLabel isRequired>{translate.role}:</FormLabel>
            <FormInput isError={check('role_id')}>
              <SelectCustom
                placeholder={translate.role}
                apiLink={'accounts/crm_roles'}
                sortKey='name'
                valueID={modalValue.role_id}
                onChange={(o) => changeValue(o.id, 'role_id')}
                error={check('role_id')}
              />
            </FormInput>
          </FormField>

          <FormField>
            <FormLabel>{translate.short_number}:</FormLabel>
            <FormInput isError={check('sipuni_short_number')}>
              <input
                placeholder={translate.short_number}
                type='number'
                value={modalValue.sipuni_short_number || ''}
                onChange={(e) =>
                  changeValue(e.target.value, 'sipuni_short_number')
                }
              />
            </FormInput>
          </FormField>
        </div>
      )}
    </div>
  )
}

export default observer(AddNewUser)
